module.exports = __webpack_public_path__ + "static/media/card_bg_10.eaf9a78e.png";